/** @format */
import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { _$, FormItem, Icon, Input, Select, Option, Spinner } from '@king-design/react'
import { TriggerConditionType, TriggerTypeEnum } from '../../container'
import variable from 'src/static/styles/var'
import { getTriggerRuleOperator, RuleKeyInput, TriggerRuleKeyEnum } from './container'
import { AddButon } from 'src/components'
import { cloneDeep } from 'lodash'
import { CountContext } from '../..'
import { eventListToOptions } from 'src/pages/EventCenter/constants'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'
import { isNumber, uniqBy } from 'lodash'

interface TriggerConditionProps {
  className?: string
  triggerType: keyof typeof TriggerTypeEnum
  orIndex: number
  conditions: TriggerConditionType[]
  onChange: (conditions: TriggerConditionType[], orIndex: number, move?: 'up' | 'down') => void
}

const TriggerCondition: React.FC<TriggerConditionProps> = ({
  className,
  triggerType,
  orIndex,
  conditions,
  onChange
}) => {
  const { eventResult } = useContext(CountContext)
  // Region
  const regionResult = useGlobalData('monitorRegionList') as RegionStateType['list']

  // 产品类型-事件类型-事件名称
  const eventOptions = useMemo(() => {
    return eventListToOptions(eventResult) || []
  }, [eventResult])

  // 修改条件，clearOtherValue=清空其他项
  const onChangeConditions = (
    value: Partial<TriggerConditionType>,
    andIndex: number,
    clearOtherValue?: boolean
  ) => {
    let copyConditions = []
    if (clearOtherValue) {
      copyConditions = conditions.map((item, index) => {
        if (index === andIndex) {
          return {
            ...item,
            ...value
          }
        } else {
          return {
            ...item,
            Value: RuleKeyInput.includes(item.Key) || item.Key === '' ? '' : []
          }
        }
      })
    } else {
      copyConditions = cloneDeep(conditions)
      copyConditions[andIndex] = {
        ...conditions[andIndex],
        ...value
      }
    }
    onChange(copyConditions, orIndex)
  }

  // 获取Value的可选项
  const getTriggerRuleValueOpts = (key, value) => {
    if (key === 'namespaceid') {
      return eventOptions?.map(item => ({
        label: item.label,
        value: item.value
      }))
    } else if (key === 'region_key') {
      return regionResult?.map(item => ({
        label: item.regionName,
        value: item.regionKey
      }))
    } else if (key === 'event_type') {
      const findProduct = eventOptions.find(item => item.value === conditions[0]?.Value)
      return (
        findProduct?.children?.map(item => ({
          label: item.label,
          value: item.value
        })) || []
      )
    } else if (key === 'event_name') {
      const findProduct = eventOptions.find(item => item.value === conditions[0]?.Value)
      const eventNameOpts = findProduct?.children?.reduce((acc, item) => {
        acc.push(
          ...item.children?.map(item => ({
            label: item.label,
            value: item.value
          }))
        )
        return acc
      }, [])
      return eventNameOpts
    } else if (key === 'event_level') {
      const filterProduct = eventResult.filter(item => item.productType === conditions[0]?.Value)
      const eventLevelOpts = filterProduct.map(item => ({
        label: item.eventLevel,
        value: item.eventLevel
      }))
      return uniqBy(eventLevelOpts, 'value')
    } else if (key === 'event_status') {
      const filterProduct = eventResult.filter(
        item => item.productType === conditions[0]?.Value && item.eventStatus
      )
      const eventStatusOpts = filterProduct.map(item => ({
        label: item.eventStatus,
        value: item.eventStatus
      }))
      return uniqBy(eventStatusOpts, 'value')
    }
    return ''
  }

  return (
    <div className={className} key={orIndex}>
      <div className="trigger_condition_header">
        <p>#{orIndex + 1}.</p>
        <div className="ksc-space">
          <Icon
            className="ion-trash-a"
            size={16}
            onClick={() => {
              onChange(undefined, orIndex)
            }}
          />
          <Icon
            className="k-icon-up"
            size={16}
            onClick={() => onChange(conditions, orIndex, 'up')}
          />
          <Icon
            className="k-icon-down"
            size={16}
            onClick={() => onChange(conditions, orIndex, 'down')}
          />
        </div>
      </div>
      <div className="trigger_condition_content">
        {conditions.map((condition, andIndex) => {
          const { Key, Operator, Value } = condition
          const valueOpts = getTriggerRuleValueOpts(Key, Value)
          const operatorOpts = getTriggerRuleOperator(Key)
          return (
            <div className="trigger_condition_content_item ksc-space" key={andIndex}>
              <FormItem hideLabel value={Key}>
                <Select
                  width={150}
                  placeholder="KEY"
                  value={Key}
                  disabled={Key === 'namespaceid'}
                  onChangeValue={value => {
                    const operatorOpts = getTriggerRuleOperator(value)
                    let initValue: string | number | string[] | number[]
                    if (RuleKeyInput.includes(value) || value === 'key') {
                      initValue = ''
                    } else if (value === 'length') {
                      initValue = 1
                    } else {
                      initValue = []
                    }
                    onChangeConditions(
                      {
                        Key: value,
                        Operator: operatorOpts[0],
                        Value: initValue
                      },
                      andIndex
                    )
                  }}
                >
                  {triggerType === 'monitor_event_agg' ? (
                    <>
                      <Option value="key">{_$("聚合Key")}</Option>
                      <Option value="length">{_$("聚合长度")}</Option>
                    </>
                  ) : (
                    Object.entries(TriggerRuleKeyEnum)
                      .filter(([value]) => andIndex === 0 || value !== 'namespaceid')
                      .map(([value, label]) => {
                        return (
                          <Option key={value} value={value}>
                            {label}
                          </Option>
                        )
                      })
                  )}
                </Select>
              </FormItem>
              <FormItem hideLabel value={Operator}>
                <Select
                  width={70}
                  placeholder=""
                  disabled={operatorOpts?.length === 1}
                  value={Operator}
                  onChangeValue={value => onChangeConditions({ Operator: value }, andIndex)}
                >
                  {operatorOpts.map(op => {
                    return (
                      <Option key={op} value={op}>
                        {op}
                      </Option>
                    )
                  })}
                </Select>
              </FormItem>
              <FormItem hideLabel value={Value} rules={{ required: andIndex === 0 }}>
                {Array.isArray(valueOpts) ? (
                  <Select
                    width={350}
                    value={Value as string[]}
                    filterable
                    multiple={Key !== 'namespaceid'}
                    nowrap={Key !== 'namespaceid'}
                    clearable={Key !== 'namespaceid'}
                    placeholder={`请选择${TriggerRuleKeyEnum[Key] || ''}`}
                    onChangeValue={value => {
                      if (andIndex === 0) {
                        onChangeConditions({ Value: value }, andIndex, true)
                      } else {
                        onChangeConditions({ Value: value }, andIndex)
                      }
                    }}
                  >
                    {valueOpts.map(item => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                ) : Key === 'length' ? (
                  <Spinner
                    width={265}
                    min={0}
                    forceStep
                    value={parseInt(Value + '')}
                    onChangeValue={value => onChangeConditions({ Value: value }, andIndex)}
                  />
                ) : (
                  <Input
                    width={350}
                    clearable
                    placeholder={
                      Key === 'xid'
                        ? _$("请输入维度值，默认全部生效，多个值请使用英文,分割")
                        : `请输入${TriggerRuleKeyEnum[Key] || ''}`
                    }
                    value={Value as string}
                    onChangeValue={value => onChangeConditions({ Value: value }, andIndex)}
                  />
                )}
              </FormItem>
              {Key !== 'namespaceid' && (
                <Icon
                  className="ion-trash-a"
                  size={16}
                  onClick={() => {
                    const copyConditions = cloneDeep(conditions)
                    copyConditions.splice(andIndex, 1)
                    onChange(copyConditions, orIndex)
                  }}
                />
              )}
            </div>
          )
        })}
        <div className="add_condition">
          <AddButon
            text={_$('并且（Add）')}
            size="small"
            type="link"
            fluid={false}
            disabled={triggerType === 'monitor_event' && !isNumber(conditions?.[0]?.Value)}
            onClick={() => {
              const copyConditions = conditions.concat([
                {
                  Key: '',
                  Value: '',
                  Operator: ''
                }
              ])
              onChange(copyConditions, orIndex)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default styled(TriggerCondition)`
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  margin-bottom: 8px;
  .k-icon {
    cursor: pointer;
    &:hover {
      color: ${variable.primaryColor};
    }
  }
  .trigger_condition_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    border-bottom: 1px solid #f0f0f0;
    p {
      margin-bottom: 0;
    }
  }
  .trigger_condition_content {
    padding: 8px;
    .no_data {
      text-align: center;
      color: #999;
      padding: 16px 0;
      margin-bottom: 0;
    }
    .add_condition {
      text-align: right;
    }
    .trigger_condition_content_item {
      align-items: flex-start;
      margin-bottom: 8px;
      .ion-trash-a {
        width: 20px;
        text-align: center;
        line-height: 32px;
      }
    }
  }
`
